import { SET_COLLAPSED, StegVisning, SetCollapseAction } from './Types';

export function setCollapsed(stegVisning: StegVisning): SetCollapseAction {
    return {
        type: SET_COLLAPSED,
        payload: stegVisning,
    };
}
